<template>
  <div>
    <div ref="regForm" id="embed-captcha"></div>
  </div>
</template>

<script>
  import * as verify from '../../../../static/js/gt';
  import { gt } from "../../../api/login";
  export default {
    name: "gt",
    data(){
      return{

      }
    },
    mounted() {
      this.init();
    },
    methods:{
      getSmsCode(captchaObj){
        captchaObj.reset();
        this.$emit('success',captchaObj.getValidate());
      },
      gt (){
        document.querySelector('.geetest_radar_tip').click();
      },
      init(){
        gt({
          t: new Date().getTime()
        }).then(res=>{
          initGeetest({
            gt: res.gt,
            challenge: res.challenge,
            new_captcha: res.new_captcha,
            product: "popup",
            offline: !res.success,
          },captchaObj=>{
            captchaObj.appendTo("#embed-captcha");
            captchaObj.onReady(()=> {
              this.captchaObj = captchaObj;
            });
            captchaObj.onError(()=> {
              captchaObj.destroy();
              console.log('error',captchaObj)
              // location.reload();
            });
            // 验证关闭
            captchaObj.onClose(()=> {
              captchaObj.hide();
            });
            // 验证成功
            captchaObj.onSuccess(()=> {
              this.getSmsCode(captchaObj);
            });
          });
        })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/modal/gt.vue